import { CONTACT_FORMS, Locales } from 'src/lib/constants';
import SelectWithController from '../Select/SelectWithController';
import { getRequiredMessage } from 'src/lib/utils';
import { formData as enEuFormData } from 'src/store/en-eu/form';
import { formData as enGbFormData } from 'src/store/en-gb/form';

const fieldData = {
  [Locales.EN_EU]: enEuFormData.numberOfEmployees,
  [Locales.EN_GB]: enGbFormData.numberOfEmployees,
};

const EmployeeCount = ({
  className = '',
  control,
  controlClassName = '',
  errors,
  inputClassName = '',
  labelClassName = '',
  locale,
  marketoKey,
  register,
  setValue,
  usePlaceholderLabels = false,
}) => {
  const shouldRender =
    (locale === Locales.EN_EU || locale === Locales.EN_GB) &&
    CONTACT_FORMS.has(+marketoKey);

  if (!shouldRender) return null;

  return (
    <SelectWithController
      className={className}
      controlClassName={controlClassName}
      inputClassName={inputClassName}
      labelClassName={labelClassName}
      autoComplete={fieldData[locale].autoComplete}
      control={control}
      describedby={fieldData[locale].describedby}
      errorMessage={errors?.[fieldData[locale].name]?.['message']}
      id={fieldData[locale].name}
      isDarkMode={false}
      label={fieldData[locale].label}
      placeholder={usePlaceholderLabels ? fieldData[locale].label : undefined}
      name={fieldData[locale].name}
      options={fieldData[locale].options}
      register={register}
      required={getRequiredMessage(fieldData[locale].label)}
      setValue={setValue}
    />
  );
};

export default EmployeeCount;
